export class Range {
  private associado:   number;
  private data_lib:    string;
  private nro_inicial: number;
  private nro_final:   number;
  private id:          number;
  private status:      string;
  private usuario:     number;

  constructor() {}

  public toJSON() {
    return {
      associado:   this.associado,
      data_lib:    this.data_lib,
      nro_inicial: this.nro_inicial,
      nro_final:   this.nro_final,
      id:          this.id,
      status:      this.status,
      usuario:     this.usuario
    }
  }

  public toClass(range) {
    this.associado   = range.associado;
    this.data_lib    = range.data_lib;
    this.nro_inicial = range.nro_inicial;
    this.nro_final   = range.nro_final;
    this.id          = range.id;
    this.status      = range.status;
    this.usuario     = range.usuario;
  }
}
